// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "web-static-state/js/" + chunkId + "." + {"548":"4722b065","774":"e4c81f6d","779":"885e6513","999":"e6b0afd1"}[chunkId] + ".js";
};